import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Linear, TimelineLite, TweenLite} from "gsap";

export class ReelDividerView extends BaseView {

    private _horizontalTexture: PIXI.Texture;
    private _verticalTexture: PIXI.Texture;
    private _layer: ScalableLayer;
    private _horDivider_1: PIXI.Sprite;
    private _horDivider_2: PIXI.Sprite;
    private _horDivider_3: PIXI.Sprite;
    private _horDivider_4: PIXI.Sprite;
    private _dividerTl: TimelineLite;

    protected initAnimations(): void {
        this.createLayer();
        this.createFixedDivider();
        this.createDynamicDividers();
    }

    public setDividerPositions(rowCount: number): void {
        if (this._dividerTl?.isActive()) {
            this._dividerTl.progress(1).kill();
        }
        this._dividerTl = new TimelineLite();
        let posX: number = TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.5,
            posY: number[] = [],
            dividerArr: PIXI.Sprite[] = [this._horDivider_1, this._horDivider_2, this._horDivider_3, this._horDivider_4];

        let tweenDuration: number = (rowCount === 3) ? 0 : TombOfAkhenatenGameConfig.instance.STONE_PRESS_DURATION,
            tweenDelay: number = (rowCount === 3) ? 0 : TombOfAkhenatenGameConfig.instance.STONE_PRESS_START_DELAY;

        if (rowCount === 4) {
            posY = [-292.5, -144, 4.5, 153];
            this._horDivider_1.visible = false;
            this._horDivider_2.visible = true;
        } else if (rowCount === 5) {
            posY = [-173.4, -54.6, 64.2, 183];
            this._horDivider_1.visible = true;
            this._horDivider_2.visible = true;
        } else {
            posY = [-490, -292, -94, 104];
            this._horDivider_1.visible = false;
            this._horDivider_2.visible = false;
        }

        for (let i: number = 0; i < dividerArr.length; i++) {
            this._dividerTl.add(TweenLite.fromTo(dividerArr[i].position, tweenDuration, {
                x: dividerArr[i].x,
                y: dividerArr[i].y
            }, {
                delay: tweenDelay,
                x: posX,
                y: posY[i],
                ease: Linear.easeNone
            }), 0);
        }
    }

    private createLayer(): void {
        this._layer = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.REEL_DIVIDERS.name);
        this._layer.position.set(TombOfAkhenatenGameConfig.instance.REEL_AREA_POS_X, 380);

        this._horizontalTexture = GameResources.getTextures("horDivider")[0];
        this._verticalTexture = GameResources.getTextures("verDivider")[0];
    }

    private createFixedDivider(): void {
        let verticalCount: number = TombOfAkhenatenGameConfig.instance.MAX_COLS + 1,
            symWidth: number = TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH + (TombOfAkhenatenGameConfig.instance.SYMBOL_LEFT_MARGIN * 2),
            horDividerPosX: number = TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.5;

        for (let i: number = 0; i < verticalCount; i++) {
            let verticalDivider: PIXI.Sprite = this.getDivider("typeV", i);

            verticalDivider.position.set((i * symWidth), 4);
            this._layer.addChild(verticalDivider);
        }

        let horizontalCount = 2;

        for (let i: number = 0; i < horizontalCount; i++) {
            let horDividerPosY: number = (i === 0) ? -290 : 301,
                item: number = (i === 0) ? 0 : 5,
                horizontalDivider: PIXI.Sprite = this.getDivider("typeH", item);

            horizontalDivider.position.set(horDividerPosX, horDividerPosY);
            this._layer.addChild(horizontalDivider);
        }
    }

    private createDynamicDividers(): void {
        this._horDivider_1 = this.getDivider("typeH", 1);
        this._horDivider_2 = this.getDivider("typeH", 2);
        this._horDivider_3 = this.getDivider("typeH", 3);
        this._horDivider_4 = this.getDivider("typeH", 4);

        this.setDividerPositions(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN);

        this._layer.addChild(this._horDivider_1, this._horDivider_2, this._horDivider_3, this._horDivider_4);
    }

    private getDivider(alignment: string, index: number): PIXI.Sprite {
        let dividerSprite: PIXI.Sprite = new PIXI.Sprite();

        dividerSprite.anchor.set(0.5);
        dividerSprite.name = (alignment === "typeH") ? "horizontal_" + index : "vertical_" + index;
        dividerSprite.texture = (alignment === "typeH") ? this._horizontalTexture : this._verticalTexture;

        return dividerSprite;
    }

    private onStonePressAbort() {
        if(this._dividerTl?.isActive()){
            this._dividerTl.progress(1);
        }
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, TOAGameEvent.ON_STONE_PRESS, (event: GameEvent) => this.setDividerPositions(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_STONE_PRESS_ABORT, () => this.onStonePressAbort());
        EventHandler.addEventListener(this, TOAGameEvent.UPDATE_REEL_POSITIONS, () => this.setDividerPositions(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN));
    }
}